<template>
<div>
	<div class="flex">
		<label v-if="label" class="label">
			{{ label }}
			<BaseRequiredStar v-if="$attrs.required" />
		</label>
		<slot name="help"></slot>
	</div>

	<input
		v-bind="$attrs"
		ref="inputRef"
		type="text"
	>
	<slot name="tip"></slot>
</div>

</template>

<script>
import { useCurrencyInput } from 'vue-currency-input';

export default {
	name: 'BaseInputMoney',
	props: {
		label: {
			type: String,
			default: ''
		}, 
		modelValue: {
			type: Number
		}
	},
	setup (props) {
		const options = {
			"locale": "pt-BR",
			"currency": "BRL",
			"currencyDisplay": "symbol",
			"hideCurrencySymbolOnFocus": true,
			"hideGroupingSeparatorOnFocus": false,
			"hideNegligibleDecimalDigitsOnFocus": false,
			"autoDecimalDigits": true,
			"autoSign": true,
			"useGrouping": true,
			"accountingSign": false
		};
		const { inputRef } = useCurrencyInput(options);

		return { inputRef, options }
	}
}
</script>